import PropTypes from 'prop-types'
import React from 'react';
import { StyleSheet, View, TouchableOpacity, ScrollView, FlatList, } from 'react-native';
import Text from 'app/components/Text'
import apiActions from 'app/utils/apiActions'
import textHelpers from 'app/utils/textHelpers'
import valueHelpers from 'app/utils/valueHelpers'
import { styleSheet, colors, sizes } from 'app/utils/styleSheet'
// import { navigationRef } from 'app/utils/RootNavigation';
import * as RootNavigation from 'app/utils/RootNavigation.js';
import { Hoverable } from 'react-native-web-hooks';

import Value from 'app/components/Value'
import TimelineEvent from 'app/components/TimelineEvent'
import { Ionicons, Entypo } from '@expo/vector-icons';

export default class TimelineGraph extends React.Component {

  static propTypes = {
    values: PropTypes.array,
    items: PropTypes.array,
  }

  constructor(props){
    super(props)
    this.msInDay = 1000*60*60*24
    let newestTimestamp = props.items[0].timestamp
    let oldestTimestamp = props.items[props.items.length-1].timestamp
    let newestDate = new Date(newestTimestamp)
    let oldestDate = new Date(oldestTimestamp)
    // let newestDate = new Date(newestTimestamp)
    // let oldestDate = new Date(oldestTimestamp)
    let days = []
    let dayTimestamps = []
    let counter = oldestDate.getTime()
    while(counter < newestDate.getTime()){
      let newDate = new Date(counter)
      newDate.setHours(0)
      newDate.setMinutes(0)
      newDate.setSeconds(0)
      newDate.setMilliseconds(0)
      let newDateString = newDate.toDateString()
      days.push(newDateString)
      dayTimestamps.push(newDate.getTime())
      counter += this.msInDay
    }
    days = days.reverse()
    dayTimestamps = dayTimestamps.reverse()
    this.state = {
      selectedValue: null,
      days,
      dayTimestamps,
    }
    console.log(days)
    console.log(this.props.items[0])
  }

  render(){
    let { values, items, } = this.props
    let { days, dayTimestamps, selectedValue, } = this.state

    return (
      <View style={[styles.wrapper]}>
        
        {/*<ScrollView horizontal inverted contentContainerStyle={[styles.row]}>*/}
        <FlatList horizontal inverted
          contentContainerStyle={styles.row}
          data={dayTimestamps}
          keyExtractor={day => `day-${day}`}
          renderItem={({ item, index }) => {
            let dayTs = item
            let i = index
            return (
              <View key={i} style={[styles.notchWrapper, 
                // {right: sizes.base*2*i}
              ]}>
              <Hoverable key={i}
                // onHoverIn={() => this.hoverIn(item)} 
                // onHoverOut={() => this.hoverOut(item)} 
              >
                {isHovered => {

                  let dayItems = items.filter(item => {
                    let ts = new Date(item.timestamp).getTime()
                    if(ts >= dayTs && ts < dayTs + this.msInDay){
                      return true
                    }
                    return false
                  })
                  let sortedDayItems = dayItems.sort((a, b) => {
                    let compA = valueHelpers.getColor(a.value)
                    let compB = valueHelpers.getColor(b.value)
                    // compA = valueHelpers.getColor(a.value, 'ancestorColors')
                    // compB = valueHelpers.getColor(b.value, 'ancestorColors')
                    return (compA < compB) ? 1 : -1
                  })
                  return (
                    <View style={styles.notchCol}>
                      {sortedDayItems.map((item,j) => {
                          // <View style={{flex:1}}>
                        return (
                            <TouchableOpacity
                              // style={{...styles.valueNotch, backgroundColor: 'red',}}
                              // style={{flex: 1}}
                              style={[
                                styles.valueNotch,
                                {backgroundColor: valueHelpers.getColor(item.value)},
                                // {backgroundColor: valueHelpers.getColor(item.value, 'ancestorColors')},
                              ]}
                              onPress={() => this.setState({selectedValue: item.value}) }
                            />
                        )
                      })}
                      {isHovered && (
                        <View style={styles.tooltip}>
                          <Text>{days[i]}</Text>
                        </View>
                      )}
                    </View>
                  )

                }}
              </Hoverable>
              </View>
            )
          }}
        />


        {selectedValue && (
          <Value hideRing 
            value={selectedValue} 
            style={{height: 'auto'}} 
            onPress={() => RootNavigation.push('Value', {value: selectedValue, id: selectedValue.id})}
            onPress={() => this.setState({selectedValue: null})}
          />
        )}

      </View>
    );
  }

  hoverIn = item => {

  }

  hoverOut = item => {
    // this.setState({})
  }

}

const styles = StyleSheet.create({  
  row: {
    alignSelf: 'stretch',
    alignItems: 'stretch', 
    zIndex: -1,
    // flex: 1, 
    height: sizes.large*5,
    paddingBottom: sizes.large,
    // borderColor: 'cyan', borderWidth: 1,
  },
  notchWrapper: {
    // position: 'absolute',
    width: sizes.base,
    top: 0,
    bottom: 0,
    // borderWidth: 1, borderColor: 'green',
    marginLeft: sizes.base,
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'stretch',
  },
  notchCol: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'stretch',
    // borderWidth: 1, borderColor: 'white',
  },
  valueNotch: {
    // borderWidth: 1,
    borderColor: 'cyan',
    width: sizes.base,
    maxHeight: sizes.base,
    flexShrink: 1,
    // flexGrow: 0,
    flex: 1,
  },
  tooltip: {
    position: 'absolute',
    top: '100%',
    width: 200,
  },
})